import {
  AppOutline,
  UserOutline
} from "antd-mobile-icons";

export const pageNavList = [
  {
    key: "/",
    title: "Home",
    icon: <AppOutline />,
  },
  //   {
  //     key: "/todo",
  //     title: "待办",
  //     icon: <UnorderedListOutline />,
  //   },
  //   {
  //     key: "/message",
  //     title: "消息",
  //     icon: <MessageOutline />,
  //   },
  {
    key: "/me",
    title: "Account",
    icon: <UserOutline />,
  },
];
